import { toast } from "sonner";
import request from "../../../../helpers/request";
import { IDeleteConfigPtMonAnalogico } from "./types";

export const deleteConfigPtMonAnalogico = async ({
  adrModulo,
  idCentral,
  idEntrada,
}: IDeleteConfigPtMonAnalogico) => {
  const url = `${process.env.REACT_APP_API}/MonAnalogico/DeleteConfig/${idCentral}/${adrModulo}/${idEntrada}`;
  const result = await request({ url, method: "delete" });

  if (result.status !== 200) {
    toast.error("Houve um erro ao excluir configuração!");
    return {
      status: result.status,
      data: result.data,
    };
  }

  if (result.status === 200) {
    toast.success("Configuração excluída com sucesso!");
    return result.data;
  }
};
